import React from "react";
import { FaBookOpen, FaMoon, FaSun } from "react-icons/fa";

import { REGLEMENT_FALLBACK_IMAGE } from "../utils/reglementInterieurUtils";

export default function ReglementPreviewCard({
  settings,
  previewUrls,
  previewDark,
  setPreviewDark,
}) {
  const content =
    settings.reglement_interieur ||
    "<p>Rédigez le règlement intérieur pour afficher ici un aperçu du rendu.</p>";

  return (
    <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

      <div className="p-4 sm:p-5 lg:p-6">
        <div className="mb-5 flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
          <div>
            <p className="text-[11px] uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
              Prévisualisation
            </p>

            <h3 className="mt-1 flex items-center gap-2 text-xl font-bold text-slate-900 dark:text-white">
              <FaBookOpen className="text-indigo-600 dark:text-indigo-300" />
              Aperçu du règlement intérieur
            </h3>

            <p className="mt-2 text-sm leading-6 text-slate-600 dark:text-slate-300">
              Vérifiez rapidement le rendu public du règlement avec ses images.
            </p>
          </div>

          <button
            type="button"
            onClick={() => setPreviewDark((value) => !value)}
            className="inline-flex items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-3 py-2 text-sm font-bold text-slate-700 transition hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800"
          >
            {previewDark ? <FaSun /> : <FaMoon />}
            {previewDark ? "Clair" : "Sombre"}
          </button>
        </div>

        <div className={previewDark ? "dark" : ""}>
          <article className="overflow-hidden rounded-[28px] border border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-950">
            <div className="relative h-64 overflow-hidden bg-slate-200 dark:bg-slate-800 sm:h-80">
              <img
                src={previewUrls.header}
                alt="En-tête règlement intérieur"
                className="h-full w-full object-cover"
                referrerPolicy="no-referrer"
                crossOrigin="anonymous"
                onError={(event) => {
                  event.currentTarget.src = REGLEMENT_FALLBACK_IMAGE;
                }}
              />

              <div className="absolute inset-0 bg-gradient-to-r from-slate-950/75 via-slate-950/35 to-transparent" />

              <div className="absolute inset-0 flex items-center">
                <div className="max-w-3xl px-6 text-white sm:px-10">
                  <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-white/75">
                    Club
                  </p>

                  <h2 className="mt-2 text-3xl font-black tracking-tight sm:text-5xl">
                    Règlement intérieur
                  </h2>

                  <p className="mt-4 max-w-2xl text-sm leading-6 text-white/85 sm:text-base">
                    Retrouvez les règles de fonctionnement, de sécurité, de vie
                    collective et d’organisation du club.
                  </p>
                </div>
              </div>
            </div>

            <div className="grid gap-8 p-5 sm:p-8 xl:grid-cols-[minmax(0,1fr),360px]">
              <div
                className="reglement-preview-content prose prose-slate max-w-none dark:prose-invert"
                dangerouslySetInnerHTML={{ __html: content }}
              />

              <aside className="space-y-4">
                <div className="overflow-hidden rounded-[24px] border border-slate-200 bg-slate-50 dark:border-slate-800 dark:bg-slate-900">
                  <img
                    src={previewUrls.first}
                    alt="Illustration règlement intérieur 1"
                    className="h-52 w-full object-cover"
                    referrerPolicy="no-referrer"
                    crossOrigin="anonymous"
                    onError={(event) => {
                      event.currentTarget.src = REGLEMENT_FALLBACK_IMAGE;
                    }}
                  />

                  <div className="p-4">
                    <p className="text-sm font-bold text-slate-900 dark:text-white">
                      Vie du club
                    </p>
                    <p className="mt-1 text-xs leading-5 text-slate-500 dark:text-slate-400">
                      Illustration associée au règlement intérieur.
                    </p>
                  </div>
                </div>

                <div className="overflow-hidden rounded-[24px] border border-slate-200 bg-slate-50 dark:border-slate-800 dark:bg-slate-900">
                  <img
                    src={previewUrls.second}
                    alt="Illustration règlement intérieur 2"
                    className="h-52 w-full object-cover"
                    referrerPolicy="no-referrer"
                    crossOrigin="anonymous"
                    onError={(event) => {
                      event.currentTarget.src = REGLEMENT_FALLBACK_IMAGE;
                    }}
                  />

                  <div className="p-4">
                    <p className="text-sm font-bold text-slate-900 dark:text-white">
                      Sécurité & respect
                    </p>
                    <p className="mt-1 text-xs leading-5 text-slate-500 dark:text-slate-400">
                      Deuxième image de présentation du règlement.
                    </p>
                  </div>
                </div>
              </aside>
            </div>
          </article>
        </div>

        <style>{`
          .reglement-preview-content h1,
          .reglement-preview-content h2,
          .reglement-preview-content h3 {
            scroll-margin-top: 120px;
          }

          .reglement-preview-content ul {
            list-style: disc;
            padding-left: 1.25rem;
          }

          .reglement-preview-content ol {
            list-style: decimal;
            padding-left: 1.25rem;
          }

          .reglement-preview-content a {
            color: #2563eb;
            text-decoration: underline;
            text-underline-offset: 3px;
          }

          .dark .reglement-preview-content a {
            color: #93c5fd;
          }

          .dark .reglement-preview-content strong,
          .dark .reglement-preview-content b {
            color: #fff;
          }
        `}</style>
      </div>
    </section>
  );
}